import React from 'react';
import Element, { CommonProps } from '../Element';

type SpanProps = CommonProps<'span'>;

const Span: React.FunctionComponent<SpanProps> = ({ children, ...props }) => {
  return (
    <Element tagName="span" {...props}>
      {children}
    </Element>
  );
};

export default Span;
